export const icons = {
  applogo: require('./icons/applogo.png'),
  activityIcon: require('./icons/activityIcon.png'),
  cup: require('./icons/cup.png'),
  dates: require('./icons/dates.png'),
  groups: require('./icons/groups.png'),
  home: require('./icons/home.png'),
  logout: require('./icons/logout.png'),
  recycleIcon: require('./icons/recycleIcon.png'),
  settings: require('./icons/settings.png'),
  markIcon: require('./icons/markIcon.png'),
  dumyProfile: require('./icons/dumyProfile.png'),
  applogo: require('./icons/applogo.png'),

  alertIcon: require('./icons/alertIcon.png'),
  calenderIcon: require('./icons/calenderIcon.png'),
  grayCameraIcon: require('./icons/grayCameraIcon.png'),
  grayGallaryIcon: require('./icons/grayGallaryIcon.png'),
  greenCameraIcon: require('./icons/greenCameraIcon.png'),
  menuIcon: require('./icons/menuIcon.png'),
  notificationIcon: require('./icons/notificationIcon.png'),
  smallCalenderIcon: require('./icons/smallCalenderIcon.png'),
  userIcon: require('./icons/userIcon.png'),
  whiteDot: require('./icons/whiteDot.png'),
  greenDot: require('./icons/greenDot.png'),
  taskIcon: require('./icons/task.png'),
  pendingIcon: require('./icons/panding.png'),
  completedIcon: require('./icons/complted.png'),
  sendIcon: require('./icons/send.png'),
  attachIcon: require('./icons/attechment.png'),
  emojiIcon: require('./icons/emoji.png'),
  micIcon: require('./icons/mic.png'),
};
export const images = {
  welcomeImage: require('./images/welcomeImage.png'),
  splashScreen: require('./images/splashScreen.png'),
  man: require('./images/man.jpeg')
};
